import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconModule } from '@pu/ui';

import { AvatarComponent } from './avatar.component';

@NgModule({
  declarations: [AvatarComponent],
  imports: [CommonModule, IconModule],
  exports: [AvatarComponent],
})
export class AvatarModule {}
